import { Injectable } from '@angular/core'
import { Subject, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private profileFormSubject = new Subject<boolean>()

  public getObservable(): Observable<boolean> {
    return this.profileFormSubject.asObservable()
  }

  public openProfileForm(): void {
    this.profileFormSubject.next(true)
  }

  public closeProfileForm(): void {
    this.profileFormSubject.next(false)
  }
}
